import React from 'react';
import { Header } from 'semantic-ui-react';

const Comp = () => {
  return (
    <Header as="h2" textAlign="center">
      Not Found
    </Header>
  );
};

export default Comp;
